import { get } from 'lodash';

const root = state => get(state, 'TransferOrderState.createEditTransfer');

export const getFetchingTransferItems = state =>
  get(root(state), 'fetchingTransferItems', false);
export const getTransferItems = state => get(root(state), 'transferItems', []);
export const getFetchTransferDetailError = state =>
  get(root(state), 'fetchTransferDetailError', null);
export const getSelectedTransferDetail = state =>
  get(root(state), 'selectedTransferDetail', null);
export const getFetchingTransferDetail = state =>
  get(root(state), 'fetchingTransferDetail', false);
export const getTransferItemsLoadingError = state =>
  get(root(state), 'transferItemsLoadingError', null);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getSubmitting = state => get(root(state), 'submitting', false);
export const getLoading = state => get(root(state), 'loading', false);
export const getToSites = state => get(root(state), 'toSites', []);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/state/createEditTransfer/selectors.js